module.exports = __webpack_public_path__ + "img/rabbit-face.8134c1d2.png";